module.exports = __webpack_public_path__ + "static/media/supprimer.246e3890.png";